import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { BareButton } from '@calendly/ui/components/bare-button';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { IconUsers } from '@calendly/ui/components/glyphs/IconUsers';
import { IconX } from '@calendly/ui/components/glyphs/IconX';
import { BodyText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { RECIPIENT_KINDS } from 'features/recaps/modals/share_modal/constants';
const containerCss = "c1ewxjjd";
const invalidContainerCss = "i1x78e14";
const Container = ({
  isInvalid = false,
  className,
  ...restProps
}) => <div {...restProps} className={classNames(containerCss, {
  [invalidContainerCss]: isInvalid
}, className)} />;
const labelCss = "lnhmtxy";
const invalidLabelCss = "ibq877i";
const removeButtonCss = "r1x9pa9m";
const invalidRemoveButtonCss = "i6ob10y";
const RecipientAvatar = ({
  recipient,
  isInvalid
}) => {
  if (recipient.kind === RECIPIENT_KINDS.USER_GROUP) {
    return <UiIcon icon={IconUsers} size="small" color={colorTextSecondary} title="" />;
  }
  if (recipient.kind === RECIPIENT_KINDS.USER_EMAIL && isInvalid) {
    return null;
  }
  return <FullStoryExclude>
      <Avatar size="x-small" letter={recipient.display.avatarLetter} src={recipient.display.avatarUrl} />
    </FullStoryExclude>;
};
const getRecipientLabel = recipient => recipient.display.name || recipient.display.email;
export const RecipientChip = ({
  recipient,
  isInvalid = false,
  onRemove
}) => {
  const label = getRecipientLabel(recipient);
  return <Container isInvalid={isInvalid} data-testid={`recipient-chip-${recipient.id}`} data-invalid={isInvalid ? 'true' : undefined}>
      <RecipientAvatar recipient={recipient} isInvalid={isInvalid} />
      <BodyText size="small" className={classNames(labelCss, {
      [invalidLabelCss]: isInvalid
    })}>
        <FullStoryMask>{label}</FullStoryMask>
      </BodyText>
      <BareButton className={classNames(removeButtonCss, {
      [invalidRemoveButtonCss]: isInvalid
    })} aria-label={`${I18n.t('publisher.action.remove')} ${label}`} onClick={onRemove}>
        <UiIcon icon={IconX} size="small" title="" />
      </BareButton>
    </Container>;
};

require("./recipient_chip.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./recipient_chip.js");